import { IAuthData } from "./dto";

export function getAuthDataFromLocalStorage() {
  const authDataJson = localStorage.getItem("authData");
  return authDataJson
    ? (JSON.parse(authDataJson) as IAuthData)
    : ({} as IAuthData);
}
